// Define gtag type for better type safety
interface GtagFunction {
    (command: 'event', eventName: string, eventParams?: Record<string, unknown>): void;
    (command: 'config', targetId: string, config?: Record<string, unknown>): void;
    (command: 'set', target: 'user_properties', params: Record<string, unknown>): void;
    (command: 'set', params: Record<string, unknown>): void;
}

declare global {
    interface Window {
        gtag?: GtagFunction;
        dataLayer?: unknown[];
    }
}

// Must run before any analytics call (see index.js). Queues commands until the GA script loads.
export const initGtagStub = (): void => {
    if(typeof window === 'undefined' || process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'development') {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    if(typeof window.gtag !== 'function') {
        window.gtag = ((...gtagArgs: unknown[]) => {
            window.dataLayer!.push(gtagArgs);
        }) as GtagFunction;
    }
};

export function logGoogleEvent(
    eventName: string,
    contentId: string | number,
    sourceTypeId: string,
    params?: Record<string, unknown>
): void {
    if(typeof window === 'undefined' || typeof window.gtag !== 'function') {
        return;
    }
    const payload: Record<string, unknown> = {
        page_path: window.location.pathname,
        page_location: window.location.href,
        ...(params ?? {}),
        content_id: String(contentId),
        source_type_id: String(sourceTypeId),
    };
    window.gtag('event', eventName, payload);
}

// Set once on login/logout/GA load — GA attaches global_user_id to subsequent hits (not per logGoogleEvent call).
export const updateAnalyticsUserId = (userId: string | number | null) => {
    if(typeof window === 'undefined' || typeof window.gtag !== 'function') {
        return;
    }
    window.gtag('set', 'user_properties', {
        global_user_id: userId ?? undefined,
    });
};
